const gcatIconCodes = new Set([
  'events',
  'facilities',
  'fire',
  'it',
  'janitorial',
  'localPolice',
  'maintenance',
  'medical',
  'paxity',
  'police',
  'private',
  'q_follower',
  'qr',
  'rescue',
  'responders',
  'security',
  'services',
  'social',
  'support',
  'upperManagement',
  'user',
  'users',
]);

// Path of a group category icon under public/images/svg/gcat, people or symbol flavour
const gcatCodeIconSrc = (gcatCode, person = true, canReturnNull = false) => {
  if (!gcatCode) {
    if (canReturnNull) return null;
    return '/images/svg/gui/question.svg';
  }

  if (gcatIconCodes.has(gcatCode)) {
    return `/images/svg/gcat/${(person) ? 'people' : 'symbol'}/${gcatCode}.svg`;
  }

  if (canReturnNull) return null;
  console.log(`gcatCodeIconSrc missing gcatCode=${gcatCode} person=${person}`);
  return '/images/svg/gui/dotdotdot.svg';
};

export default gcatCodeIconSrc;
